import './meta-info.scss';
import { bindable, containerless } from 'aurelia-framework';

@containerless
export class MetaInfo {
  @bindable title: string;
  @bindable text: string;
  @bindable to: string;
  @bindable toNewTab = false;
  @bindable icon: string;
}
